import * as React from "react";
import { useSelector } from "react-redux";
import { Segment, Container, Header } from "semantic-ui-react";

import { taskSelector } from "../../task/selectors";

import { ReferralReport } from "./ReferralReport";

interface OwnProps {
    version: number;
    oldVersionRedirectUrl?: string;
}

export const QAAmendReferralReport: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    const task = useSelector(taskSelector);

    if (!task) {
        return null;
    }

    return (
        <Container>
            <Segment>
                <Header as="h3">Amend Report and resubmit for QA</Header>
                {task.notes}
            </Segment>
            <ReferralReport
                version={props.version}
                nextTaskRequired={true}
                oldVersionRedirectUrl={props.oldVersionRedirectUrl}
            />
        </Container>
    );
};
